export { Logger, StatusType, HandlerType } from './domain/logger';
export { datadogLogs } from './boot/logs.entry';
//# sourceMappingURL=index.js.map